// @flow
import React from 'react'
import styled from 'styled-components'

const Component = styled.div`
  background: #fff;
  width: 400px;
  max-width: 100%;
  padding: 1rem;
  border-radius: 2px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  z-index: 1;
`

const AuthCard = ({ children }: { children?: any }) => (
  <Component>{children}</Component>
)

export default AuthCard



// WEBPACK FOOTER //
// ./src/components/AuthCard/index.js